import { createContext as e, useCallback as t, useContext as n, useSyncExternalStore as r } from "react";
import { jsx as i } from "react/jsx-runtime";
//#region src/client.ts
var a = class {
	constructor(e) {
		this.features = {}, this.attributes = {}, this.listeners = /* @__PURE__ */ new Set(), this.snapshot = this.features, e && (this.attributes.url = e);
	}
	get url() {
		return this.attributes.url ?? "";
	}
	async init() {
		await this.refreshFeatures();
	}
	async refreshFeatures() {
		try {
			let e = await fetch(`${this.url}/api/features`);
			if (!e.ok) throw Error("Failed to fetch features");
			this.features = (await e.json()).features, this.updateSnapshot();
		} catch (e) {
			console.error(e);
		}
	}
	getFeatureValue(e, t) {
		let n = this.features[e];
		return n && n.defaultValue !== void 0 ? n.defaultValue : t;
	}
	getFeatures() {
		return this.features;
	}
	setAttributes(e) {
		this.attributes = {
			...this.attributes,
			...e
		};
	}
	getAttributes() {
		return this.attributes;
	}
	async setPayload(e) {
		this.features = e.features, this.updateSnapshot();
	}
	subscribe(e) {
		return this.listeners.add(e), () => {
			this.listeners.delete(e);
		};
	}
	getSnapshot() {
		return this.snapshot;
	}
	async getCoinPrice(e) {
		return this.request(`coin-price/${e}`);
	}
	async getMonitorNetwork(e) {
		return this.request("monitor-network", { project: e });
	}
	async getProductAnalyticsConfig() {
		return this.request("product-analytics");
	}
	async checkRestricted() {
		return (await fetch(`${this.url}/api/restricted/`, {
			method: "POST",
			headers: {
				accept: "",
				"content-type": "application/json"
			},
			body: JSON.stringify({})
		})).status === 403;
	}
	async request(e, t, n) {
		let r = `${this.url}/${e}`, i = t && Object.keys(t).length > 0 ? `${r}?${new URLSearchParams(t)}` : r, a = await fetch(i, n);
		if (!a.ok) throw Error("Unexpected response");
		return a.json();
	}
	updateSnapshot() {
		this.snapshot = { ...this.features }, this.listeners.forEach((e) => e());
	}
}, o = e(null);
function s({ client: e, children: t }) {
	return /* @__PURE__ */ i(o.Provider, {
		value: e,
		children: t
	});
}
function c() {
	let e = n(o);
	if (!e) throw Error("useAppsBackendClient must be used within an AppsBackendClientProvider");
	return e;
}
function l(e) {
	let n = c(), i = r(t((e) => n.subscribe(e), [n]), t(() => n.getSnapshot(), [n]))[e]?.defaultValue ?? null;
	return {
		value: i,
		on: !!i,
		off: !i
	};
}
function u(e, t) {
	let { value: n } = l(e);
	return n ?? t;
}
function d(e) {
	let { on: t } = l(e);
	return t;
}
//#endregion
export { a as AppsBackendClient, s as AppsBackendClientProvider, c as useAppsBackendClient, l as useFeature, d as useFeatureIsOn, u as useFeatureValue };

//# sourceMappingURL=index.es.js.map